import { BillOfLadingLogs } from './BillOfLadingLogs';

export default BillOfLadingLogs;
